import { EndpointRequest } from "../../_system/EndpointRequest";
import {
  ReadSupplementsGroupsRequestDto as RequestDto,
  ReadSupplementsGroupsResponseDto as ResponseDto,
} from "../../api/supplements/listGroups/dtos";
import { Api } from "../../api";

type Data = {
  id: number;
  name: string;
}[];
export const listGroups = new EndpointRequest<RequestDto, ResponseDto, Data>(
  "LIST_SUPPLEMENTS_GROUPS",
  Api.supplements.listGroups,
  ({ data: { data } }) => data
);
